import { AbilityBuilder, createMongoAbility } from "@casl/ability";

/** 通用权限判断所需的最小当前用户结构。 */
export type PermissionUser = {
  permissions?: string[];
  isSuperuser?: boolean;
};

/** 根据实时权限码构建 CASL Ability。 */
export function buildPermissionAbility(permissions: string[], isSuperuser = false) {
  const { can, build } = new AbilityBuilder(createMongoAbility);
  if (isSuperuser) {
    can("manage", "all");
  }
  for (const permissionCode of new Set(permissions)) {
    can("use", permissionCode);
  }
  return build();
}

/** 判断当前用户是否具备指定通用功能权限。 */
export function canUsePermission(user: PermissionUser | null | undefined, permissionCode: string): boolean {
  if (!user) return false;
  if (user.isSuperuser) return true;
  return buildPermissionAbility(user.permissions ?? []).can("use", permissionCode);
}

/** CRM 操作固定使用“通用功能权限 AND CRM 数据权限”。 */
export function canAccessCrmOperation(
  user: PermissionUser | null | undefined,
  permissionCode: string,
  crmDataAllowed: boolean,
): boolean {
  return crmDataAllowed && canUsePermission(user, permissionCode);
}

/**
 * 从旧 scope 构建兼容 Ability。
 */
export function buildAbility(scopes: string[]) {
  const ability = buildPermissionAbility(scopes);
  if (scopes.includes("dashboard:read")) {
    const { can, build } = new AbilityBuilder(createMongoAbility);
    can("read", "Dashboard");
    return build();
  }
  return ability;
}

/**
 * 兼容判断旧工作台 scope。
 */
export function canReadDashboard(scopes: string[]): boolean {
  return buildAbility(scopes).can("read", "Dashboard");
}

